import React from "react";
import { useMediaQuery, Flex, Box, Text, Link } from "@chakra-ui/react";
import { colors } from "../../definitions/constants/GlobalStyles";
import i18n from "../../i18n/i18n";
import { SendIcon } from "../../definitions/constants/IconsComponent";
import { postStore } from "../../zustand/globalStore";

export function Comments({ post }: { post: any }) {
  const [isMobile] = useMediaQuery("(max-width: 992px)");
  const { setShowCommentsModal, setSelectedPost } = postStore((state) => state);

  return (
    <Box p={isMobile ? "2" : "0"}>
      <Flex
        justify="space-between"
        align="center"
        p={2}
        paddingLeft="20px"
        bg={colors.figmaColors.grey0}
        borderRadius="20px"
        height="40px"
        cursor="pointer"
        onClick={() => {
          setSelectedPost(post);
          setShowCommentsModal(true);
        }}
      >
        <Text
          fontSize="13px"
          fontWeight="400"
          lineHeight="18.51px"
          color={colors.figmaColors.grey3}
        >
          {i18n.t("write a comment")}
        </Text>
        <SendIcon cursor="pointer" />
      </Flex>
    </Box>
  );
}

export default Comments;
